import React, { useRef, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { FaRocket, FaUsers, FaStar } from 'react-icons/fa';
import { Link } from 'react-router-dom';

const Apply = () => {
  const { t } = useTranslation();
  const applyRef = useRef();
  
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('animate-in');
          }
        });
      },
      { threshold: 0.1 }
    );

    if (applyRef.current) observer.observe(applyRef.current);

    return () => observer.disconnect();
  }, []);
  
  return (
    <section className="apply-modern py-5" ref={applyRef}>
      <div className="container text-center mt-5">
        {/* Section Header */}
        <div className="section-header mb-5 fade-in-up stagger-1">
          <div className="section-badge">
            <FaStar className="me-2" />
            <span>{t('apply.badge')}</span>
          </div>
          <h2 className="section-title text-glow text-white mb-4">
            {t('apply.title')}
          </h2>
          <div className="section-decoration mx-auto"></div>
        </div>

        {/* Main Content */}
        <div className="apply-content fade-in-up stagger-2">
          <div className="h5 text-white-50 mb-4 apply-description">
            {t('apply.description')}
          </div>
          
          {/* Call to Action */}
          <div className="apply-actions fade-in-up stagger-3">
            <Link 
              to="https://apply.mileageriot.com" 
              className="btn btn-hero-primary btn-lg pulse-glow"
            >
              <FaRocket className='me-2'/>
              {t('header.buttons.join')}
            </Link>
            
            <div className="apply-stats mt-4">
              <div className="stat-item">
                <FaUsers className="stat-icon-small text-primary" />
                <span className="text-white-50">500+ {t('apply.activeMembers')}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      {/* Background Effects */}
      <div className="apply-bg-decoration"></div>
    </section>
  );
};

export default Apply;